export const site = {
    gtmId: 'GTM-NWHX2TS',

    url: 'https://prestalo.com',

    name: 'Prestalo',
    title: 'Prestalo.com',
    separator: ' | ',

    lang: {
        head: 'es',
        meta: 'es',
    },

    hreflang: [],

    socialMedia: [
        { url: 'https://www.facebook.com/prestalo.oficial' },
        { url: 'https://twitter.com/prestalo_online' },
        { url: 'https://www.instagram.com/prestalo_online/' },
        { url: 'https://www.tiktok.com/@prestalo.com' },
    ],

    nif: 'B-67285288',

    contact: {
        phone: '932 715 764',
        email: 'hola@prestalo.com',

        address: {
            street: 'Carrer de Tuset 8',
            city: 'Barcelona',
            postalCode: '08006',
            addressCountry: 'ES',
        },
    },
};
